import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { setMinimizeSidebar } from "./chatsSlice";
import { VideoSettings } from "../../Types/VideoSuite-Types";

export interface ImageModelsItem {
  modelVersion: string;
  modelName: string;
}
export interface WorkflowImageAppSettings {
  imageModels: ImageModelsItem[];
  imageDimensions: string[];
}

interface WorkflowItem {
  appId: string;
  appType: string;
  suiteType: number;
  icon?: string;
  appOrder: number;
  data: any;
  inputType: string;
  outputType: string;
}
export interface WorkflowsType {
  name: string;
  id: string;
  apps: WorkflowItem[];
  workflowType:number
}
export interface SuitesAppTypes {
  id: string;
  suiteType: number;
  appType: string;
  inputType: string;
  outputType: string;
  order: number;
}
export interface workflowAppResultsType{
  id: string,
  appId:string
  workflowAppId:string,
  input: string,
  output: string
}
export interface WorkflowRunsType{
  id: string,
  workflowId: string,
  name: string,
  createdAt: string,
  workflowAppResults: workflowAppResultsType[] |[];
}

interface WorkflowRunData {
  runId: string;
}
export interface WorkflowsData {
  allWorkflows: WorkflowsType[];
  updateWorkflow: WorkflowsType;
  CurrentWorkflowSelected: WorkflowsType;
  textSuitesApps: SuitesAppTypes[];
  selectedWorkflowData: WorkflowsType;
  GenerateingResponse: boolean;
  minimizeSidebarWorkflow: boolean;
  workflowName: string;
  WorkflowImageAppSetting: WorkflowImageAppSettings;
  allWorkflowRuns:WorkflowRunsType[];
  selectedWorkflowRun:WorkflowRunsType;
  videoAppSetting: VideoSettings[],
  isWorkflowRunFinished: boolean;
  currentWorkflowRunData: WorkflowRunData;
}
const initialState: WorkflowsData = {
  allWorkflows: [],
  CurrentWorkflowSelected: {
    name: "",
    id: "",
    apps: [],
    workflowType:0
  },
  updateWorkflow: {
    name: "",
    id: "",
    apps: [],
    workflowType:0
  },
  textSuitesApps: [],
  selectedWorkflowData: {
    name: "",
    id: "",
    apps: [],
    workflowType:0
  },
  GenerateingResponse: false,
  minimizeSidebarWorkflow: false,
  workflowName: "",
  WorkflowImageAppSetting: {imageDimensions: [], imageModels: []},
  allWorkflowRuns:[
    {
      id: "",
      workflowId:"",
      name: "",
      createdAt:"",
      workflowAppResults: []
    }
  ],
  selectedWorkflowRun: {
    id: "",
    workflowId:"",
    name: "",
    createdAt:"",
    workflowAppResults: []
  },
  videoAppSetting: [{
    name: "",
    version: "",
    generationTime: "0",
    modelVideoQualities: [],
    modelDurations: [{ value: 0 }],
    modelStyles: [],
    modelDimensions: [],
    seed: 0,
  }],
  isWorkflowRunFinished: false,
  currentWorkflowRunData:{runId:""},
};
const workflowsSlice = createSlice({
  name: "WorkflowsSlice",
  initialState: initialState,
  reducers: {
    setAllWorkflows(state, action: PayloadAction<any>) {
      state.allWorkflows = [];
      state.allWorkflows = action.payload.map((workflow: any) => ({
        id: workflow?.id,
        name: workflow?.name,
        workflowType:workflow.workflowType,
        apps: workflow?.apps?.map((app: any) => ({
          appId: app.appId,
          appType: app.appType,
          suiteType: app.suiteType,
          inputType: app.inputType,
          outputType: app.outputType,
          appOrder: app.appOrder,
          data: app?.payload ? JSON.parse(app?.payload) : {},
        })),
      }));
    },
    setAllWorkflowRuns(state, action: PayloadAction<WorkflowRunsType[]>) {
      state.allWorkflowRuns = [];
      state.allWorkflowRuns = action.payload.map((workflow: any) => ({
        id: workflow?.id,
        workflowId:workflow.workflowId,
        name: workflow?.name,
        createdAt:workflow.createdAt,
        workflowAppResults: workflow?.workflowAppResults?.map((app: any) => ({
          id: app.id,
          appId:app.appId,
          workflowAppId: app.workflowAppId,
          input: app.input,
          output: app.output,
        })),
      }));
    }, 
    setSelectedWorkflowRun(state, action: PayloadAction<WorkflowRunsType>) {
      state.selectedWorkflowRun ={
        id:action.payload.id,
        name:action.payload.name,
        workflowId:action.payload.workflowId,
        createdAt:action.payload.createdAt,
        workflowAppResults:action.payload.workflowAppResults
      } 
    }, 
    UpadteWorkflowById(state, action: PayloadAction<any>) {
      const index = state.allWorkflows.findIndex(
        (workflow) => workflow.id === action.payload.id
      );
      const updatedWorkflow = {
        ...action.payload,
        apps: action.payload.apps.map((app: any) => ({
          id: app.id,
          appType: app.appType,
          suiteType: app.suiteType,
          inputType: app.inputType,
          outputType: app.outputType,
          appOrder: app.appOrder,

          data: app?.payload ? JSON.parse(app?.payload) : {},
        })),
      };

      if (index !== -1) {
        // Update the existing workflow
        state.allWorkflows[index] = updatedWorkflow;
      } else {
        // Optionally add it if it doesn't exist
        state.allWorkflows.push(updatedWorkflow);
      }
    },
    removeWorkflowById(state, action: PayloadAction<string>) {
      state.allWorkflows = state.allWorkflows.filter(
        (workflow) => workflow.id !== action.payload
      );
    },
    removeWorkflowRunById(state, action: PayloadAction<string>) {
      state.allWorkflowRuns = state.allWorkflowRuns.filter(
        (workflow) => workflow.id !== action.payload
      );
    },
    setUpdateWorkflowSelected(state, action: PayloadAction<WorkflowsType>) {
      state.updateWorkflow = action.payload;
    },
    setCurrentWorkflowSelected(state, action: PayloadAction<WorkflowsType>) {
      state.CurrentWorkflowSelected = action.payload;
    },
    setVideoAppSettings(state, action: PayloadAction<VideoSettings[]>){
       state.videoAppSetting=[];
       state.videoAppSetting=action.payload
    },
    setMinimizeSidebarWorkflow(state, action: PayloadAction<boolean>) {
      state.minimizeSidebarWorkflow = action.payload;
    },
    setAllTextSuitesApps(state, action: PayloadAction<SuitesAppTypes[]>) {
      state.textSuitesApps = [];
      state.textSuitesApps = action.payload;
    },
    setSelectedWorkflowData(state, action: PayloadAction<WorkflowsType>) {
      state.selectedWorkflowData = action.payload;
    },
    setWorkflowNameStore(state, action: PayloadAction<string>) {
      state.workflowName = action.payload;
    },
    setGenerateingResponse(state, action: PayloadAction<boolean>) {
      state.GenerateingResponse = action.payload;
    },
    setWorkflowImageAppSetting(
      state,
      action: PayloadAction<WorkflowImageAppSettings>
    ) {
      state.WorkflowImageAppSetting = action.payload;
    },
    setIsWorkflowRunFinished(state, action: PayloadAction<boolean>) {
      state.isWorkflowRunFinished = action.payload;
    },
    setCurrentWorkflowRunData(state, action: PayloadAction<WorkflowRunData>) {
      state.currentWorkflowRunData = action.payload;
    },
  },
});

export const {
  setAllWorkflows,
  setWorkflowNameStore,
  setMinimizeSidebarWorkflow,
  setGenerateingResponse,
  removeWorkflowById,
  setCurrentWorkflowSelected,
  setUpdateWorkflowSelected,
  UpadteWorkflowById,
  setAllTextSuitesApps,
  setSelectedWorkflowData,
  setWorkflowImageAppSetting,
  setAllWorkflowRuns,
  setVideoAppSettings,
  setSelectedWorkflowRun,
  removeWorkflowRunById,
  setIsWorkflowRunFinished,
  setCurrentWorkflowRunData
} = workflowsSlice.actions;

export default workflowsSlice.reducer;
